import { Component, OnInit, Input } from '@angular/core';
import { DeviceApplication } from 'src/app/models/device-models/device-application-model/device-application.model';

@Component({
  selector: 'app-device-list-apps-card',
  templateUrl: './device-list-apps-card.component.html',
  styleUrls: ['./device-list-apps-card.component.scss']
})
export class DeviceListAppsCardComponent implements OnInit {

  @Input() deviceApplications: DeviceApplication[];

  constructor() { }

  ngOnInit() {}
}
